import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

declare global {
  interface Window {
    clarity: (command: string, ...args: any[]) => void;
  }
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'heal-angular-payment';

  ngOnInit(): void {
    if (environment.production) {
      this.executeClarityMethod()
    }
  }
  
  private executeClarityMethod() {
    try {
      const hashIndex = window.location.href.indexOf('#');
      const hashQuery = hashIndex !== -1 ? window.location.href.substring(hashIndex + 1) : '';
      const urlParams = new URLSearchParams(hashQuery.split('?')[1]);

      const pid = urlParams.get('pid');

      if (pid) {
        if (window.clarity && typeof window.clarity === 'function') {
          window.clarity('identify', pid, 'Patient ID');
        } else {
          console.warn('Clarity script not yet loaded.');
        }
      }
    } catch (e) {
      console.error('Error identifying user for Clarity:', e);
    }
  }
}
